import api from './axios'

// 마이페이지 접속 시 등록 여부 정보 받기
// isChildRegister, isVoiceRegister
export const getRegisterInfo = async() => {
  const res = await api.get("users/child-info")
  return res.data
}